import React, { Component } from 'react';
import { has, isArray, isEmpty, isNil, map } from 'lodash';
import { UpdateModeHeader } from 'js/components/elements/schema-editor/schema-browser/UpdateModeHeader/UpdateModeHeader';
import JSONUtils from '../../../../lib/JSONUtils';
import LoadableMonacoEditor from '../../editors/monaco/LoadableMonacoEditor';
import UserConfirmation from '../../../route_utils/UserConfirmation';
import { SchemaEditorViewModeType } from 'js/constants/schemaEditor';
import { RESOURCE_TYPE_SCHEMA_SPECS } from 'js/constants/resourceTypes';

class SchemaBrowserSamples extends Component {
  state = {
    saveRequested: false,
  };

  handleCancelJSONMode = () => {
    this.props.onViewModeChanged(SchemaEditorViewModeType.TABLE);
  };

  render() {
    const {
      samples,
      customSamplesCode,
      showMeta,
      isEditable = false,
      allowCacheSave = true,
      liveSamples,
      isLoading,
      onEdit,
      onResetClicked,
      resource,
      resourceType,
      darkEditor,
    } = this.props;

    const { saveRequested } = this.state;
    const customCodeExists = !isNil(customSamplesCode);
    let isCustomCodeValid = false;
    let code;

    if (resourceType === RESOURCE_TYPE_SCHEMA_SPECS) {
      const displayCode = {
        schema: resource?.schema,
        samples: resource?.data_samples,
      };
      code = JSONUtils.parseToFormat(displayCode, 'application/json');
    } else if (customCodeExists) {
      code = customSamplesCode;
      isCustomCodeValid = isArray(JSONUtils.parseJson(customSamplesCode));
    } else if (isLoading) {
      code = 'Loading...';
    } else {
      let processedSamples;

      if (!showMeta && isArray(samples) && !isEmpty(samples)) {
        processedSamples = map(samples, (s) => (has(s, 'rawMessage') ? s.rawMessage : s));
      } else {
        processedSamples = samples;
      }
      code = JSONUtils.parseToFormat(processedSamples, 'application/json');
    }

    const headerTitle = allowCacheSave ? 'Edit Cached Samples' : 'Edit Testing Samples';

    return (
      <>
        <div className="schema-browser-samples">
          {isEditable || liveSamples ? (
            <UpdateModeHeader
              title={headerTitle}
              isModified={customCodeExists}
              disableOnUpdateBtn={!isCustomCodeValid}
              showUpdateButton={allowCacheSave}
              onCancelClick={customCodeExists ? onResetClicked : this.handleCancelJSONMode}
              onUpdateClick={this._handleSaveClicked}
            />
          ) : null}
          <LoadableMonacoEditor
            height="100%"
            language="json"
            theme={darkEditor ? 'dark' : 'light'}
            value={code}
            onChange={onEdit}
            options={{
              minimap: { enabled: false },
              readOnly: !isEditable || isLoading,
            }}
          />
        </div>

        {saveRequested && (
          <UserConfirmation
            title="Update Cache"
            message="The first five samples currently displayed in Nexset Input will be added to the cache. Would you like to continue?"
            cancelButtonLabel="Cancel"
            okButtonLabel="Save"
            okButtonTheme="primary"
            onCancel={this._handleSaveCanceled}
            onConfirm={this._handleSaveConfirmed}
          />
        )}
      </>
    );
  }

  _handleSaveClicked = () => {
    this.setState({ saveRequested: true });
  };

  _handleSaveConfirmed = () => {
    const { onSaveClicked } = this.props;
    this.setState({ saveRequested: false });
    onSaveClicked();
  };

  _handleSaveCanceled = () => {
    this.setState({ saveRequested: false });
  };
}

export default SchemaBrowserSamples;
